import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import InfoIcon from '@mui/icons-material/Info';
import Tooltip from '@mui/material/Tooltip';
import {
  IN_ROOM_DINING_CATEGORY_DAYS,
  IN_ROOM_DINING_CATEGORY_TAB,
  IN_ROOM_DINING_CATEGORY_TYPE,
} from '../../../../../constants/InRoomDiningConst';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import CustomFormView from '../../../../../shared/custom-form-view/Custom-Form-View';
import ImageUpload from '../../../../../shared/image-upload/ImageUpload';
import { allHotelsSelector } from '../../../../property/propertySlice';
import { formDataValidate } from '../../../../../utils/formUtils';
import CustomCheckbox from '../../../../../shared/form-controls/custom-checkbox/Custom-Checkbox';
import './Category-Create.scss';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import {
  addInRoomDiningCategory,
  editInRoomDiningCategory,
} from '../../../../../utils/ServicesAPIUtils';
import { fetchAllInRoomDining, fetchAllInRoomDiningMenu } from '../../../servicesSlice';
import { getProcessedImages } from '../../../../../shared/image-upload/ImageProcessor';
import CustomHours from '../../../../../shared/custom-hours/Custom-Hours';
import KeyValuePairList from '../../../../../shared/key-value-pair-list/KeyValuePairList';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const InRoomDiningCategoryCreate = (props) => {
  const { toggleDrawer, category, hotelId, restaurantId, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [rawImages, setRawImages] = useState([]);
  const [days, setDays] = useState();
  const [customTime, setCustomTime] = useState([]);
  const [customTimeError, setCustomTimeError] = useState(false);
  const originalHotels = useSelector(allHotelsSelector);
  const [isTabInValid, setIsTabInValid] = useState(true);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    name: {
      value: '',
      fieldName: 'Category Name',
      errors: {},
      validations: ['required', 'maxLength'],
      maxLength: 100,
      tab: 0,
    },
    code: {
      value: '',
      fieldName: 'Category Code',
      errors: {},
      validations: ['required', 'validAlphaNumeric'],
      tab: 0,
    },
    description: {
      value: '',
      fieldName: 'Description',
      errors: {},
      validations: [],
      tab: 0,
    },
    status: {
      value: true,
      fieldName: 'Active',
      errors: {},
      validations: [],
      tab: 0,
    },
    menu: {
      value: { url: '', type: '' },
      fieldName: 'Menu',
      errors: {},
      validations: [],
      tab: 0,
    },
    customAttributes: {
      value: [],
      fieldName: 'Custom Attributes',
      errors: {},
      validations: [],
      tab: 0,
    },
    availableOn: {
      value: 'everyDay',
      fieldName: 'availableOn',
      errors: {},
      validations: [],
      tab: 1,
    },
    days: {
      value: [],
      fieldName: 'days',
      errors: {},
      validations: [],
      tab: 1,
    },
    hours: {
      value: 'allTime',
      fieldName: 'Hours',
      errors: {},
      validations: [],
      tab: 1,
    },
    from: {
      value: '11:00',
      fieldName: 'Hours From',
      errors: {},
      validations: ['required', 'validTime'],
      tab: 1,
    },
    to: {
      value: '23:00',
      fieldName: 'Hours To',
      errors: {},
      validations: ['required', 'validTime'],
      tab: 1,
    },
    images: {
      value: [],
      fieldName: 'Images',
      errors: {},
      validations: [],
      tab: 2,
    },
  });

  useEffect(() => {
    if (category) {
      const currFields = { ...formData };
      for (let field in currFields) {
        currFields[field].value = category[field];
      }
      if (category.hours.timings.length > 0) {
        const isEveryDay = category.hours.timings.find((r) => r.day === 'EVERYDAY');
        currFields.availableOn.value = isEveryDay ? 'everyDay' : 'custom';
        currFields.hours.value = category.hours.allTime ? 'allTime' : 'custom';
        const daysToMap = formatArrayForDisplay(category?.hours?.timings);
        setCustomTime(daysToMap);
        currFields.from.value = '11:00';
        currFields.to.value = '23:00';
      }
      currFields.images.value = category.images || [];
      currFields.customAttributes.value = category.customAttributes || [];

      setFormData(currFields);
    }
  }, [category, setFormData]);

  const formatArrayForDisplay = (selectedDay) => {
    const daysToReturn = [];
    let daysList = [...selectedDay];
    while (daysList.length > 0) {
      const firstObject = daysList[0];
      const filteredRows = daysList.filter(
        (dayKey) => dayKey.from === firstObject.from && dayKey.to === firstObject.to,
      );
      daysToReturn.push({
        days: filteredRows.map(
          (filteredRowDaysName) =>
            `${filteredRowDaysName.day.charAt(0).toUpperCase()}${filteredRowDaysName.day
              .slice(1)
              .toLowerCase()}`,
        ),
        from: filteredRows[0].from,
        to: filteredRows[0].to,
      });
      const tempDaysList = [...daysList];
      filteredRows.forEach((filteredRowsItem) => {
        const findFilteredDayIndex = tempDaysList.findIndex(
          (tempDaysListItem) => tempDaysListItem.day === filteredRowsItem.day,
        );
        tempDaysList.splice(findFilteredDayIndex, 1);
      });
      daysList = [...tempDaysList];
    }
    return daysToReturn;
  };

  const validate = (tabValue) => {
    const updatedFields = {};
    // If tabValue is given, filter out the form fields in current tab
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  const resetDaysData = () => {
    const daysArray = IN_ROOM_DINING_CATEGORY_DAYS.map((daysValue, ndx) => {
      return {
        id: ndx + 1,
        name: daysValue.name,
        ischecked: false,
        from: null,
        to: null,
      };
    });
    setDays(daysArray);
  };

  useEffect(() => {
    resetDaysData();
  }, []);

  const handleSubmit = async (e) => {
    try {
      dispatch(stepUpLoaderCount());
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      e.preventDefault();
      if (!validate(0)) {
        if (!validate(0)) setTabValue(0);
        notificationManager('danger', 'Enter all required fields');
        return false;
      }
      if (customTime.length === 0) {
        setTabValue(1);
        notificationManager('danger', 'Enter all required fields');
        return false;
      }
      toggleDrawer('', false, '');
      setLoading(true);
      const images = await getProcessedImages(
        rawImages,
        originalHotels.find((hotel) => hotel.id === hotelId).groupId,
        IN_ROOM_DINING_CATEGORY_TYPE,
        hotelId,
      );
      let selectedDay = null;
      let timings = [];
      for (let i = 0; i < customTime.length; i++) {
        if (customTime[i].days && customTime[i].days.length > 0) {
          for (let j = 0; j < customTime[i].days.length; j++) {
            timings.push({
              day: customTime[i].days[j].toUpperCase(),
              from: customTime[i].from,
              to: customTime[i].to,
            });
          }
        }
      }
      selectedDay = {
        everyday: customTime[0].name === 'Everyday' ? true : false,
        allTime: customTime[0].from === 'all day' ? true : false,
        timings,
      };
      let payload = {
        name: formData.name.value,
        code: formData.code.value,
        description: formData.description.value,
        status: formData.status.value,
        customAttributes: formData.customAttributes.value,
        hours: selectedDay,
        images,
        hotelId,
        restaurantId,
      };
      if (category?.id) {
        payload.id = category?.id;
        await editInRoomDiningCategory(payload, language);
        notificationManager('success', 'Category updated successfully');
      } else {
        await addInRoomDiningCategory(payload, language);
        notificationManager('success', 'Category created successfully');
      }
      dispatch(fetchAllInRoomDining(hotelId, restaurantId));
      dispatch(fetchAllInRoomDiningMenu(hotelId, restaurantId));
      setLoading(false);
    } catch (error) {
      notificationManager(
        'danger',
        error?.graphQLErrors ? error?.graphQLErrors?.[0]?.message : 'Category not added',
      );
      setLoading(false);
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    }
    if (tabValue === 1) {
      if (customTime.length === 0) {
        setCustomTimeError(true);
        return false;
      }
    }
    if (validate(tabValue)) {
      setTabValue(newValue);
    }
  };

  const onImageListUpdated = (imgObjArr) => {
    setRawImages(imgObjArr);
  };

  const onUploadedImageRemoval = (index) => {
    const images = [...formData.images];
    images.splice(index, 1);
    setFormData({ images });
  };

  const onCancel = (e) => {
    toggleDrawer('', false, '');
  };

  const onClickNext = () => {
    if (tabValue === 1) {
      if (customTime.length === 0) {
        setCustomTimeError(true);
        return false;
      }
    }
    if (validate(tabValue)) {
      setTabValue(tabValue + 1);
    }
  };

  useEffect(() => {
    const currTabFromData = Object.fromEntries(
      Object.entries(formData).filter(([key, field]) => field.tab === tabValue),
    );
    const isValid = formDataValidate(currTabFromData, false);
    tabValue === 1 ? setIsTabInValid(!customTime.length) : setIsTabInValid(!isValid);
  }, [formData, tabValue, customTime]);

  return (
    <CustomFormView
      handleSubmit={handleSubmit}
      tabTitle={IN_ROOM_DINING_CATEGORY_TAB}
      onCancel={onCancel}
      tabValue={tabValue}
      maxtab={2}
      isTabInValid={isTabInValid}
      isUpdate={category ? true : false}
      loading={loading}
      handleTabChange={handleTabChange}
      title={`${category ? 'Edit' : 'Add'} Category`}
      onClickNext={onClickNext}
      titleClass='col-md-4'
      tabClass='col-md-4'
      cancelClass='col-md-4 '
    >
      {tabValue === 0 && (
        <div className='col-md-12 mb-3 form-scroll'>
          <h4 className='tab-title'>Details</h4>
          <div className='row'>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.name}
                handleInputChange={(e) => {
                  setFormData({ name: e });
                }}
                maxLength={100}
                endAdornment={true}
                characterCount={true}
                multiline={true}
              />
            </div>
            <div className='col-md-6 mb-3'>
              <CustomTextField
                item={formData.code}
                handleInputChange={(e) => {
                  setFormData({ code: e });
                }}
                maxLength={8}
                endAdornment={true}
                characterCount={true}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12 mb-3'>
              <CustomTextField
                item={formData.description}
                handleInputChange={(e) => {
                  setFormData({ description: e });
                }}
                multiline={true}
              />
            </div>
          </div>
          <div className='row w-100 d-flex mt-2'>
            <div className='col-md-3 mb-3'>
              <div className='d-flex align-items-center'>
                <CustomCheckbox
                  item={formData.status}
                  handleInputChange={(e) => {
                    setFormData({ status: e });
                  }}
                  color='primary'
                />
                <Tooltip title='Deactivating this, hides it from Guest app' placement='right-end'>
                  <InfoIcon fontSize='small' style={{ cursor: 'pointer' }} />
                </Tooltip>
              </div>
            </div>
          </div>
          <KeyValuePairList
            item={formData.customAttributes}
            onListChange={(e) => {
              setFormData({ customAttributes: e });
            }}
          />
        </div>
      )}
      {tabValue === 1 && (
        <div className='col-md-12 mb-3 form-scroll'>
          <CustomHours
            setFormData={setFormData}
            formData={formData}
            days={days}
            customTime={customTime}
            setCustomTime={setCustomTime}
            validate={validate}
            tabValue={tabValue}
            customTimeError={customTimeError}
            setCustomTimeError={setCustomTimeError}
          />
        </div>
      )}
      {tabValue === 2 && (
        <div className='col-md-12 mb-3 form-scroll'>
          <ImageUpload
            uploadedImages={formData.images.value}
            imgList={rawImages}
            onImageListUpdated={onImageListUpdated}
            onUploadedImageRemoval={onUploadedImageRemoval}
            onImagesLoading={(status) => {
              setLoading(status);
            }}
            enabledMediaTabs={['image']}
          />
        </div>
      )}
    </CustomFormView>
  );
};

export default InRoomDiningCategoryCreate;
